import React from 'react'
import { Users } from 'lucide-react'
import { accentColor, isValidHex } from '../utils/teamColors'

/**
 * Аватар банды: квадрат с рамкой цвета оформления.
 * `ava: null` — заглушка с иконкой состава, чтобы карточки каталога
 * не «проваливались» пустыми блоками.
 */
const TeamAvatar = ({ team, size = 56, className = '' }) => {
  const colors = team?.colors
  const accent = accentColor(colors)
  const frame = isValidHex(colors?.avatar_frame) ? colors.avatar_frame : accent

  return (
    <div
      className={`relative shrink-0 overflow-hidden rounded-xl border-2 ${className}`}
      style={{
        width: size,
        height: size,
        borderColor: frame,
        boxShadow: `0 0 16px ${frame}44`
      }}
    >
      <div className="flex h-full w-full items-center justify-center bg-dark-primary">
        {team?.ava ? (
          <img
            src={team.ava}
            alt={team.name || ''}
            className="h-full w-full object-cover"
            onError={(e) => {
              e.currentTarget.style.display = 'none'
              if (e.currentTarget.nextElementSibling) {
                e.currentTarget.nextElementSibling.style.display = 'flex'
              }
            }}
          />
        ) : null}
        <span
          className={`h-full w-full items-center justify-center ${team?.ava ? 'hidden' : 'flex'}`}
          style={{ color: accent }}
        >
          <Users size={Math.round(size * 0.42)} />
        </span>
      </div>
    </div>
  )
}

export default TeamAvatar
